import { HTMLAttributes, PropsWithChildren } from "react";
import { PageRoot } from "./Page.styles";

export type PageVariant = "default" | "orders";

export interface PageProps extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
	variant?: PageVariant;
}

/**
 * Shared page frame. It owns only the visual canvas so pages can keep their
 * existing data, permissions, and navigation behaviour.
 */
const Page = ({ children, className, variant = "default", ...rest }: PageProps) => (
	<PageRoot
		className={className}
		data-page-variant={variant}
		variant={variant}
		{...rest}
	>
		{children}
	</PageRoot>
);

export default Page;
